(() => {
  const savedKey = 'fsp_vehicle_v1';
  const fields = ['year', 'make', 'model', 'submodel'];
  const json = (url) => {
    const requestUrl = new URL(url, location.origin);
    if (requestUrl.hostname.endsWith('.chatgpt.site')) requestUrl.searchParams.set('_fspv', '20260728-1');
    const direct = () => fetch(requestUrl.href, { cache: 'no-store', headers: { Accept: 'application/json' } }).then((response) => {
      if (!response.ok) throw new Error(`Request failed (${response.status})`);
      return response.json();
    });
    if (!requestUrl.hostname.endsWith('.chatgpt.site')) return direct();
    return direct().catch(() => fetch(`https://r.jina.ai/${requestUrl.href}`, { cache: 'no-store' }).then(async (response) => {
      if (!response.ok) throw new Error(`Fitment fallback failed (${response.status})`);
      const text = await response.text();
      const marker = 'Markdown Content:';
      const start = text.indexOf(marker);
      if (start < 0) throw new Error('Fitment fallback returned an unexpected response');
      return JSON.parse(text.slice(start + marker.length).trim());
    }));
  };
  const money = (cents) => new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
    style: 'currency', currency: window.Shopify?.currency?.active || 'USD'
  }).format(cents / 100);
  const vehicleFrom = (selects) => {
    const vehicle = Object.fromEntries(fields.map((field) => [field, selects[field].value]));
    vehicle.label = fields.map((field) => vehicle[field]).join(' ');
    return vehicle;
  };
  const enhanceSelect = (select) => {
    if (!select || select.dataset.customReady) return;
    select.dataset.customReady = 'true';
    select.classList.add('fsp-custom-select__native');
    const wrap = document.createElement('div'); wrap.className = 'fsp-custom-select';
    select.parentNode.insertBefore(wrap, select); wrap.append(select);
    const trigger = document.createElement('button'); trigger.type = 'button'; trigger.className = 'fsp-custom-select__trigger';
    trigger.setAttribute('aria-haspopup', 'listbox'); trigger.setAttribute('aria-expanded', 'false');
    const menu = document.createElement('div'); menu.className = 'fsp-custom-select__menu'; menu.hidden = true;
    const search = document.createElement('input'); search.type = 'search'; search.className = 'fsp-custom-select__search';
    search.placeholder = `Search ${select.name === 'submodel' ? 'submodel' : select.name || 'options'}`;
    search.setAttribute('aria-label', search.placeholder); search.autocomplete = 'off';
    const options = document.createElement('div'); options.className = 'fsp-custom-select__options'; options.setAttribute('role', 'listbox');
    menu.append(search, options); wrap.append(trigger, menu);
    const close = () => {
      wrap.classList.remove('is-open'); menu.hidden = true; trigger.setAttribute('aria-expanded', 'false'); search.value = '';
    };
    const render = () => {
      const selected = select.options[select.selectedIndex];
      trigger.textContent = selected?.textContent || `Select ${select.name || 'option'}`;
      wrap.classList.toggle('is-disabled', select.disabled); trigger.disabled = select.disabled;
      const query = search.value.trim().toLowerCase();
      const matches = [...select.options].filter((option) => option.value && option.textContent.toLowerCase().includes(query));
      options.replaceChildren();
      if (!matches.length) {
        const empty = document.createElement('div'); empty.className = 'fsp-custom-select__empty'; empty.textContent = 'No matching options';
        options.append(empty); return;
      }
      matches.forEach((option) => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'fsp-custom-select__option';
        button.setAttribute('role', 'option'); button.setAttribute('aria-selected', String(option.selected));
        button.classList.toggle('is-selected', option.selected); button.textContent = option.textContent;
        button.addEventListener('click', () => {
          select.value = option.value; select.dispatchEvent(new Event('change', { bubbles: true })); close(); trigger.focus();
        });
        options.append(button);
      });
    };
    trigger.addEventListener('click', () => {
      document.querySelectorAll('.fsp-custom-select.is-open').forEach((node) => {
        if (node !== wrap) node.querySelector('.fsp-custom-select__trigger')?.click();
      });
      const open = !wrap.classList.contains('is-open');
      wrap.classList.toggle('is-open', open); menu.hidden = !open; trigger.setAttribute('aria-expanded', String(open));
      if (open) { render(); requestAnimationFrame(() => search.focus()); }
    });
    search.addEventListener('input', render);
    select.addEventListener('change', render);
    new MutationObserver(render).observe(select, { childList: true, subtree: true, attributes: true });
    document.addEventListener('click', (event) => { if (!wrap.contains(event.target)) close(); });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && wrap.classList.contains('is-open')) { close(); trigger.focus(); }
    });
    render();
  };

  document.querySelectorAll('[data-fsp-vehicle-shop]').forEach((root) => {
    if (root.dataset.ready) return;
    root.dataset.ready = '1';
    const apiA = root.dataset.apiA.replace(/\/$/, '');
    const apiB = root.dataset.apiB.replace(/\/$/, '');
    const apiForYear = (year) => Number(year) < 2000 ? apiA : apiB;
    const form = root.querySelector('[data-vehicle-selector]');
    const selects = Object.fromEntries(fields.map((field) => [field, form.elements[field]]));
    const submit = form.querySelector('[type="submit"]');
    const message = root.querySelector('[data-vehicle-message]');
    const results = root.querySelector('[data-vehicle-results]');
    const grid = root.querySelector('[data-results-grid]');
    const pages = root.querySelector('[data-results-pages]');
    const typeSelect = root.querySelector('[data-product-type]');
    const state = { cursor: null, limit: 24, vehicle: null, type: '', loading: false };
    root.querySelectorAll('select').forEach(enhanceSelect);

    const fill = (field, values) => {
      selects[field].innerHTML = `<option value="">Select ${field}</option>`;
      values.forEach((value) => selects[field].add(new Option(value, value)));
      selects[field].disabled = false;
    };
    const loadOptions = (field) => {
      const params = new URLSearchParams();
      fields.slice(0, fields.indexOf(field)).forEach((prior) => params.set(prior, selects[prior].value));
      if (field === 'year') {
        return Promise.all([apiA, apiB].map((base) => json(`${base}/options?field=year`)))
          .then((responses) => [...new Set(responses.flatMap((data) => data.options || []))]
            .sort((a, b) => String(a).localeCompare(String(b), undefined, { numeric: true, sensitivity: 'base' })))
          .then((values) => fill(field, values));
      }
      params.set('field', field);
      return json(`${apiForYear(selects.year.value)}/options?${params}`).then((data) => fill(field, data.options || []));
    };
    const resetAfter = (index) => {
      fields.slice(index + 1).forEach((field) => {
        selects[field].innerHTML = `<option value="">Select ${field}</option>`;
        selects[field].disabled = true;
      });
      submit.disabled = true;
    };
    fields.slice(0, -1).forEach((field, index) => selects[field].addEventListener('change', () => {
      resetAfter(index);
      if (selects[field].value) loadOptions(fields[index + 1]).catch(() => {
        message.textContent = 'Vehicle data is temporarily unavailable. Please try again.';
      });
    }));
    selects.submodel.addEventListener('change', () => { submit.disabled = !selects.submodel.value; });

    const enrich = async (product) => {
      try {
        const shopify = await json(`${window.Shopify.routes.root}products/${encodeURIComponent(product.handle)}.js`);
        const variant = shopify.variants.find((item) => Number(item.id) === Number(product.variant_id)) || shopify.variants[0];
        return {
          ...product,
          price: product.price ?? variant?.price,
          image: product.image || shopify.featured_image,
          available: Boolean(shopify.available && variant?.available)
        };
      } catch { return { ...product, available: false }; }
    };
    const card = (product) => {
      const article = document.createElement('article');
      article.className = 'fsp-fitment-product';
      const href = `/products/${encodeURIComponent(product.handle)}?variant=${encodeURIComponent(product.variant_id)}`;
      const imageLink = document.createElement('a');
      imageLink.className = 'fsp-fitment-product__image'; imageLink.href = href;
      if (product.image) {
        const image = document.createElement('img'); image.src = product.image; image.loading = 'lazy'; image.alt = product.title;
        imageLink.append(image);
      }
      const body = document.createElement('div'); body.className = 'fsp-fitment-product__body';
      const vendor = document.createElement('small'); vendor.textContent = product.vendor || '';
      const heading = document.createElement('h3'); const link = document.createElement('a'); link.href = href; link.textContent = product.title;
      heading.append(link); body.append(vendor, heading);
      if (product.price != null) { const price = document.createElement('strong'); price.textContent = money(Number(product.price)); body.append(price); }
      article.append(imageLink, body); return article;
    };
    const renderMore = (nextCursor) => {
      pages.replaceChildren();
      if (!nextCursor) return;
      const button = document.createElement('button'); button.type = 'button'; button.textContent = 'Load more compatible parts';
      button.addEventListener('click', () => {
        state.cursor = nextCursor;
        loadProducts(true).catch(() => {
          state.loading = false;
          message.textContent = 'More compatible products could not be loaded. Please try again.';
        });
      });
      pages.append(button);
    };
    const loadTypes = async () => {
      if (!typeSelect || !state.vehicle) return;
      const params = new URLSearchParams({ field: 'type', ...state.vehicle }); params.delete('label');
      const data = await json(`${apiForYear(state.vehicle.year)}/options?${params}`);
      typeSelect.replaceChildren(new Option('All product types', ''));
      (data.options || []).forEach((type) => typeSelect.add(new Option(type, type)));
      typeSelect.value = state.type;
    };
    const loadProducts = async (append = false) => {
      if (!state.vehicle || state.loading) return;
      state.loading = true; message.textContent = 'Loading compatible products…'; results.hidden = false;
      if (!append) grid.replaceChildren();
      const params = new URLSearchParams({ ...state.vehicle, limit: String(state.limit) });
      params.delete('label'); if (state.type) params.set('type', state.type);
      if (state.cursor) params.set('cursor', state.cursor);
      const data = await json(`${apiForYear(state.vehicle.year)}/products?${params}`);
      const enriched = (await Promise.all((data.items || []).map(enrich))).filter((product) => product.available);
      enriched.forEach((product) => grid.append(card(product)));
      if (!append && !enriched.length) {
        const empty = document.createElement('p'); empty.textContent = 'No verified compatible products were found for this selection.';
        grid.append(empty);
      }
      root.querySelector('[data-results-title]').textContent = `Parts for ${state.vehicle.label}`;
      renderMore(data.nextCursor);
      message.textContent = data.nextCursor ? 'More verified compatible products are available.' : 'All verified compatible products are shown.';
      const url = new URL(location.href);
      fields.forEach((field) => url.searchParams.set(field, state.vehicle[field]));
      if (state.type) url.searchParams.set('type', state.type); else url.searchParams.delete('type');
      url.searchParams.delete('page'); url.searchParams.delete('cursor'); history.replaceState({}, '', url);
      state.loading = false;
    };

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const vehicle = vehicleFrom(selects);
      localStorage.setItem(savedKey, JSON.stringify(vehicle));
      window.dispatchEvent(new CustomEvent('fsp:vehicle-saved', { detail: vehicle }));
      if (root.dataset.showResults !== 'true') {
        const url = new URL(root.dataset.resultsUrl, location.origin);
        fields.forEach((field) => url.searchParams.set(field, vehicle[field]));
        location.assign(url);
        return;
      }
      state.vehicle = vehicle; state.cursor = null; state.type = '';
      loadTypes().then(() => loadProducts()).catch(() => { state.loading = false; message.textContent = 'Compatible products could not be loaded. Please try again.'; });
    });
    typeSelect?.addEventListener('change', () => {
      state.type = typeSelect.value; state.cursor = null;
      loadProducts().catch(() => { state.loading = false; message.textContent = 'Compatible products could not be loaded. Please try again.'; });
    });

    loadOptions('year').then(async () => {
      const query = new URLSearchParams(location.search);
      const saved = JSON.parse(localStorage.getItem(savedKey) || 'null');
      const selected = Object.fromEntries(fields.map((field) => [field, query.get(field) || saved?.[field] || '']));
      for (let index = 0; index < fields.length; index += 1) {
        const field = fields[index];
        if (!selected[field]) return;
        selects[field].value = selected[field];
        if (index < fields.length - 1) await loadOptions(fields[index + 1]);
      }
      submit.disabled = false;
      if (root.dataset.showResults === 'true') {
        state.vehicle = vehicleFrom(selects);
        state.type = query.get('type') || '';
        state.cursor = null;
        await loadTypes();
        await loadProducts();
      }
    }).catch(() => { message.textContent = 'Vehicle data is temporarily unavailable. Please try again.'; });
  });
})();
